export const hyperspeedPresets = {
  one: {
    onSpeedUp: () => {},
    onSlowDown: () => {},
    distortion: 'turbulentDistortion',
    length: 400,
    roadWidth: 10,
    islandWidth: 2,
    lanesPerRoad: 3,
    fov: 90,
    fovSpeedUp: 150,
    speedUp: 2,
    carLightsFade: 0.4,
    totalSideLightSticks: 20,
    lightPairsPerRoadWay: 40,
    shoulderLinesWidthPercentage: 0.05,
    brokenLinesWidthPercentage: 0.1,
    brokenLinesLengthPercentage: 0.5,
    lightStickWidth: [0.12, 0.5],
    lightStickHeight: [1.3, 1.7],
    movingAwaySpeed: [60, 80],
    movingCloserSpeed: [-120, -160],
    carLightsLength: [400 * 0.03, 400 * 0.2],
    carLightsRadius: [0.05, 0.14],
    carWidthPercentage: [0.3, 0.5],
    carShiftX: [-0.8, 0.8],
    carFloorSeparation: [0, 5],
    colors: {
      // THEME: "The Pitch" (Classic Soccer)
      roadColor: '#083308',       // Deep Turf Green
      islandColor: '#083308',     // Dark Divider
      background: '#000500',      // Night Stadium Black/Green
      shoulderLines: '#ffffff',   // Chalk White Field Lines
      brokenLines: '#ffffff',     // Chalk White
      leftCars: ['#ff0000', '#d50000', '#b71c1c'], // Red Card / Home Kit
      rightCars: ['#ffd700', '#ffea00', '#ffc107'], // Yellow Card / Referee / Ball
      sticks: '#ffffff'           // Bright Floodlights
    }
  },
  two: {
    onSpeedUp: () => {},
    onSlowDown: () => {},
    distortion: 'mountainDistortion',
    length: 400,
    roadWidth: 20,
    islandWidth: 1,
    lanesPerRoad: 3,
    fov: 90,
    fovSpeedUp: 150,
    speedUp: 2,
    carLightsFade: 0.4,
    totalSideLightSticks: 50,
    lightPairsPerRoadWay: 50,
    shoulderLinesWidthPercentage: 0.05,
    brokenLinesWidthPercentage: 0.1,
    brokenLinesLengthPercentage: 0.5,
    lightStickWidth: [0.12, 0.5],
    lightStickHeight: [1.3, 1.7],
    movingAwaySpeed: [60, 80],
    movingCloserSpeed: [-120, -160],
    carLightsLength: [400 * 0.05, 400 * 0.15],
    carLightsRadius: [0.05, 0.14],
    carWidthPercentage: [0.3, 0.5],
    carShiftX: [-0.2, 0.2],
    carFloorSeparation: [0.05, 1],
    colors: {
      // THEME: "The Tennis Court" (Grass Court)
      roadColor: '#001100',       // Vibrant Lawn Green
      islandColor: '#ffffff',     // white divider for contrast
      background: '#000000',      // Dark Green Void
      shoulderLines: '#ffffff',   // Baseline White
      brokenLines: '#f0f0f0',
      leftCars: ['#ff0000', '#00d9ff', '#ff1744'], // Bright "Home Jersey" Red
      rightCars: ['#2979ff', '#2962ff', '#00b0ff'], // Electric "Away Jersey" Blue
      sticks: ['#ff0000', '#ffd700']           // red and yellow cards for variety and visibility
    }
  },
  three: {
    onSpeedUp: () => {},
    onSlowDown: () => {},
    distortion: 'xyDistortion',
    length: 400,
    roadWidth: 9,
    islandWidth: 2,
    lanesPerRoad: 3,
    fov: 90,
    fovSpeedUp: 150,
    speedUp: 3,
    carLightsFade: 0.4,
    totalSideLightSticks: 50,
    lightPairsPerRoadWay: 30,
    shoulderLinesWidthPercentage: 0.05,
    brokenLinesWidthPercentage: 0.1,
    brokenLinesLengthPercentage: 0.5,
    lightStickWidth: [0.02, 0.05],
    lightStickHeight: [0.3, 0.7],
    movingAwaySpeed: [20, 50],
    movingCloserSpeed: [-150, -230],
    carLightsLength: [400 * 0.05, 400 * 0.2],
    carLightsRadius: [0.03, 0.08],
    carWidthPercentage: [0.1, 0.5],
    carShiftX: [-0.5, 0.5],
    carFloorSeparation: [0, 0.1],
    colors: {
       // THEME: "Friday Night Lights" (Gridiron)
      roadColor: '#1a4d2e',       // Football Field Green
      islandColor: '#0d2818',
      background: '#050f0a',
      shoulderLines: '#ffd700',   // Goal Post Gold
      brokenLines: '#ffffff',     // Yard Lines
      leftCars: ['#d50000', '#b71c1c', '#c62828'], // Home Jersey Red
      rightCars: ['#2962ff', '#2979ff', '#448aff'], // Away Jersey Blue
      sticks: '#ffd700'           // Championship Trophy Gold
    }
  },
  four: {
    onSpeedUp: () => {},
    onSlowDown: () => {},
    distortion: 'LongRaceDistortion',
    length: 400,
    roadWidth: 10,
    islandWidth: 5,
    lanesPerRoad: 2,
    fov: 90,
    fovSpeedUp: 150,
    speedUp: 2,
    carLightsFade: 0.4,
    totalSideLightSticks: 50,
    lightPairsPerRoadWay: 70,
    shoulderLinesWidthPercentage: 0.05,
    brokenLinesWidthPercentage: 0.1,
    brokenLinesLengthPercentage: 0.5,
    lightStickWidth: [0.12, 0.5],
    lightStickHeight: [1.3, 1.7],
    movingAwaySpeed: [60, 80],
    movingCloserSpeed: [-120, -160],
    carLightsLength: [400 * 0.05, 400 * 0.15],
    carLightsRadius: [0.05, 0.14],
    carWidthPercentage: [0.3, 0.5],
    carShiftX: [-0.2, 0.2],
    carFloorSeparation: [0.05, 1],
    colors: {
      // THEME: "Tactical Board" (High Contrast)
      roadColor: '#002200',       // Very Dark Tactical Green
      islandColor: '#001100',
      background: '#000000',
      shoulderLines: '#ff0000',   // Tactical Arrow Red
      brokenLines: '#ffffff',     // Chalk
      leftCars: ['#ffffff', '#e0e0e0', '#cccccc'], // White Team
      rightCars: ['#ffff00', '#ffea00', '#ffd600'], // Yellow Team
      sticks: '#ff0000'           // Red Zone Indicators
    }
  },
  five: {
    onSpeedUp: () => {},
    onSlowDown: () => {},
    distortion: 'turbulentDistortion',
    length: 400,
    roadWidth: 9,
    islandWidth: 2,
    lanesPerRoad: 3,
    fov: 90,
    fovSpeedUp: 150,
    speedUp: 2,
    carLightsFade: 0.4,
    totalSideLightSticks: 50,
    lightPairsPerRoadWay: 50,
    shoulderLinesWidthPercentage: 0.05,
    brokenLinesWidthPercentage: 0.1,
    brokenLinesLengthPercentage: 0.5,
    lightStickWidth: [0.12, 0.5],
    lightStickHeight: [1.3, 1.7],
    movingAwaySpeed: [60, 80],
    movingCloserSpeed: [-120, -160],
    carLightsLength: [400 * 0.05, 400 * 0.15],
    carLightsRadius: [0.05, 0.14],
    carWidthPercentage: [0.3, 0.5],
    carShiftX: [-0.2, 0.2],
    carFloorSeparation: [0.05, 1],
    colors: {
      // THEME: "Broadcast Overlay" (Modern TV)
      roadColor: '#1b5e20',       // Standard Broadcast Green
      islandColor: '#0f3310',
      background: '#000000',
      shoulderLines: '#00e5ff',   // Cyan "Live" Overlay lines
      brokenLines: '#ffffff',
      leftCars: ['#ff1744', '#d50000', '#ff5252'], // Live Red
      rightCars: ['#ffffff', '#f5f5f5', '#eeeeee'], // Data White
      sticks: '#00e5ff'           // Data Blue
    }
  },
  six: {
    onSpeedUp: () => {},
    onSlowDown: () => {},
    distortion: 'deepDistortion',
    length: 400,
    roadWidth: 18,
    islandWidth: 2,
    lanesPerRoad: 3,
    fov: 90,
    fovSpeedUp: 150,
    speedUp: 2,
    carLightsFade: 0.4,
    totalSideLightSticks: 50,
    lightPairsPerRoadWay: 50,
    shoulderLinesWidthPercentage: 0.05,
    brokenLinesWidthPercentage: 0.1,
    brokenLinesLengthPercentage: 0.5,
    lightStickWidth: [0.12, 0.5],
    lightStickHeight: [1.3, 1.7],
    movingAwaySpeed: [60, 80],
    movingCloserSpeed: [-120, -160],
    carLightsLength: [400 * 0.05, 400 * 0.15],
    carLightsRadius: [0.05, 0.14],
    carWidthPercentage: [0.3, 0.5],
    carShiftX: [-0.2, 0.2],
    carFloorSeparation: [0.05, 1],
    colors: {
      // THEME: "The Derby" (High Stakes)
      roadColor: '#004d40',       // Teal/Green mix (Night game)
      islandColor: '#00251a',
      background: '#000000',
      shoulderLines: '#ffffff',
      brokenLines: '#ffffff',
      leftCars: ['#d50000', '#c62828', '#b71c1c'], // Aggressive Red
      rightCars: ['#ffd600', '#ffea00', '#ffff00'], // Warning Yellow
      sticks: '#ffffff'           // Stadium White
    }
  }
};